import './App.css';
import './index.css';
import { Toaster } from 'sonner';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Root from './routes/root';

const App = () => (
  <I18nextProvider i18n={i18n}>
    <div className="App">
      <Toaster richColors position="bottom-right" />
      <Root />
    </div>
  </I18nextProvider>
);

export default App;